import React from 'react'

import Svg from './svg'


export default function AddIcon({width, height, color, ...props}) {
    color = getComputedStyle(document.documentElement)
        .getPropertyValue(color || '--on-content') || color

    return <Svg width={width || '16px'} height={height || '16px'} viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g id="sort" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path d="M43,10 L57,10 L57,43 L90,43 L90,57 L57,57 L57,90 L43,90 L43,57 L10,57 L10,43 L43,43 Z" id="Shape" fill={color || "white"}></path>
        </g>
    </Svg>
}
